import { Box, Button, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import { UserPlus } from "tabler-icons-react";
import LeaveRequestTable from "./components/tableLeave";

export default function MyLeaveRequest() {
  const [opened, setOpened] = useState(false);
  return (
    <Box p="lg">
      <Group position="apart" mb="md">
        <Title order={2}>My Leave Request</Title>
        <Group>
          {/* <Button
            leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add Leave
          </Button> */}
        </Group>
      </Group>
      <Divider mb="md" />
      <LeaveRequestTable />
      {/* <AddLeaveRequestModal opened={opened} onClose={() => setOpened(false)} /> */}
    </Box>
  );
}
